import { MultiStepFormState } from '@delmonicos/shared-design-system-react/src/contexts/multi-step-form-item';
import {
  MultiStepFormProvider,
  SubmitHandlerWithDirtyFields,
} from '@delmonicos/shared-design-system-react/src/contexts/multi-step-form.provider';
import { GetUsersPaginatedModel } from '@delmonicos/shared-sdk/libs/cpms/src/apps/charge-point-operators-gateway/src/users/models/inputs/get-users-paginated.model';
import { SubmitErrorHandler } from 'react-hook-form';

import { useFilterUserListContext } from '../../user.context';
import { UserListFilterFormStep1Controller } from '../user-list-filter-form-step-1/user-list-filter-form-step-1.controller';

export interface UserListFilterFormControllerProps {
  onError: SubmitErrorHandler<GetUsersPaginatedModel>;
  onSubmit: SubmitHandlerWithDirtyFields<GetUsersPaginatedModel>;
  onCancel: () => void;
  state: MultiStepFormState;
}

export const UserListFilterFormController = (
  props: UserListFilterFormControllerProps,
): React.JSX.Element => {
  const { onError, onSubmit, onCancel, state } = props;
  const data = useFilterUserListContext();

  return (
    <MultiStepFormProvider<GetUsersPaginatedModel>
      useFormProps={{
        mode: 'all',
        defaultValues: data,
      }}
      submitErrorHandler={onError}
      submitHandler={onSubmit}
      onCancel={onCancel}
      state={state}
      items={[
        {
          fields: ['customerId', 'roleId'],
          component: <UserListFilterFormStep1Controller />,
        },
      ]}
    />
  );
};
